/**
 * The care tips the detail page shows (SPEC-003 D-4).
 *
 * The reference draws three columns — Water, Pruning, Winter care. No content
 * pack carries a winter-care string, so the columns are whatever the pack DOES
 * have rather than sentences this module made up: the order below is the order a
 * gardener needs it in, and the first three filled fields win.
 */

/**
 * Tried in this order; the first `MAX_CARE_TIPS` with content are shown.
 *
 * `care.maintenance` is absent on purpose. The packs fill it with the same bare
 * label the decision plate already shows — "Easy", "Low" — and a tip whose body
 * is one adjective is not a tip.
 */
export const CARE_TIP_ORDER = ['water', 'pruning', 'planting', 'soil'];

export const MAX_CARE_TIPS = 3;

const TIP_SOURCES = {
    water: { proseKey: 'watering', labelKey: 'plants.property.water' },
    pruning: { proseKey: 'pruning', labelKey: 'plants.detail.pruning' },
    planting: { proseKey: 'planting', labelKey: 'plants.detail.planting' },
    soil: { proseKey: 'soil', labelKey: 'plants.property.soil' },
};

/**
 * A tip carries either literal pack prose (`text`) or a message key (`textKey`),
 * never both — the caller translates one and renders the other as-is, which is
 * what keeps untranslatable pack content and translatable chrome copy apart.
 */
function tipFromProse(key, text) {
    return { key, labelKey: TIP_SOURCES[key].labelKey, text, textKey: null };
}

export function selectCareTips(plant, limit = MAX_CARE_TIPS) {
    const care = plant?.prose?.care || {};

    // A missing field drops its column rather than borrowing the property note
    // from the plate above. Lavender is the one pack with no `care.watering`
    // (SPEC-002), and an earlier draft filled its Water tip that way — which put
    // "Water when soil is mostly dry." twice on the same screen, an inch apart.
    return CARE_TIP_ORDER
        .map((key) => {
            const text = care[TIP_SOURCES[key].proseKey];

            return text ? tipFromProse(key, text) : null;
        })
        .filter(Boolean)
        .slice(0, limit);
}
